import { jsx } from "react/jsx-runtime";
import { event } from "@zillow/universal-analytics";
import { debounce } from "lodash";
import { useFormState } from "react-hook-form";
import EmailField from "../Fields/EmailField.esm.js";
import NameField from "../Fields/NameField.esm.js";
import PhoneField from "../Fields/PhoneField.esm.js";
import TextField from "../Fields/TextField.esm.js";
const FieldComponents = {
  email: EmailField,
  name: NameField,
  text: TextField,
  phone: PhoneField
};
const sendInteractionEvent = (cmsInfo) => {
  const newLaneData = {
    envelope: {
      event_type_id: "2056",
      event_type_version_id: "2",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_form",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_engagement"
    },
    cms_info: cmsInfo
  };
  event(newLaneData);
};
const handleFieldChange = debounce((value, type) => {
  const cmsInfo = {
    block_type_cd: "form_field",
    block_id: type || "",
    block_displayed_txt: value.target.name || ""
  };
  sendInteractionEvent(cmsInfo);
}, 3e3);
const SimonField = ({
  type,
  defaultValue,
  name,
  help,
  label,
  options,
  placeholder,
  required
}) => {
  const FieldComponent = FieldComponents[type] || TextField;
  const formStateProxy = useFormState();
  const formState = {
    isSubmitting: formStateProxy.isSubmitting
  };
  return /* @__PURE__ */ jsx(FieldComponent, { config: {
    validate: (value) => {
      if (required && !value) {
        return "Required";
      }
      return null;
    }
  }, label, defaultValue, name, required, description: help, placeholder, options, disabled: formState.isSubmitting, onChange: (value) => {
    handleFieldChange(value, type);
  } });
};
export {
  SimonField as default
};
